<script>
	// Stores 
	import { 
		textWhatsappDocumentacao,
		linkWhatsappDocumentacao,
		mailDocumentacao
	 } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Documentação Necessária';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<div class="box-itens-icon">
		<div class="item">
			<div class="icone">
				<i class="fas fa-user fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Candidato à Locatário - Pessoa Fisíca</h3>
				<p>Trazer documentos originais juntamente com cópias:</p>
				<ul class="list-cycle">
					<li>CPF e RG (Carteira de Identidade ou CNH)</li>
					<li>Comprovante de residência (Conta de luz, telefone, etc.)</li>
					<li>Comprovantes de rendimentos:
						<ul class="list-cycle">
							<li>Contracheque e Carteira Profissional atualizada ou pró-labore</li>
							<li>Declaração e notificação completa do Imposto de Renda</li>
						</ul>
					</li>
					<li><b>Obs.: A renda deverá ser de, no mínimo, três vezes o valor do aluguel mais encargos.</b></li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-shield fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Candidato à Fiador - Pessoa Fisíca</h3>
				<p>Trazer documentos originais juntamente com cópias:</p>
				<ul class="list-cycle">
					<li>CPF e RG (Carteira de Identidade ou CNH), se for casado(a), também da esposa(o)</li>
					<li>Comprovante de residência (Conta de luz, telefone, etc.)</li>
					<li>Comprovantes de rendimentos:
						<ul class="list-cycle">
							<li>Contracheque e Carteira Profissional atualizada ou pró-labore</li>
							<li>Declaração e notificação completa do Imposto de Renda</li>
							<li>É necessário apresentar os 03 últimos extratos</li>
						</ul>
					</li>
					<li><b>Obs.: A renda deverá ser de, no mínimo, três vezes o valor do aluguel mais encargos.</b></li>
					<li><b>Somente poderão candidatar-se à fiador pessoas com até 70 anos</b></li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-briefcase fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Candidato à Locatário - Pessoa Jurídica - Empresa</h3>
				<p>Trazer documentos originais juntamente com cópias:</p>
				<ul class="list-cycle">
					<li>Contrato Social e alterações e certidão especifica da Junta Comercial</li>
					<li>Último balanço</li>
					<li>Último balancete semestral</li>
					<li>Última Declaração do Imposto de Renda</li>
					<li>Cartão do CNPJ</li>
				</ul>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-user-tie fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Candidato à Locatário - Pessoa Jurídica - Sócios</h3>
				<p>Trazer documentos originais juntamente com cópias:</p>
				<ul class="list-cycle">
					<li>CPF e RG (Carteira de identidade ou CNH)</li>
				</ul>
				<p><b>OBS.: Independentemente da apresentação de garantias adicionais, os sócios assinarão na qualidade de fiadores, assim, será necessário CPF e RG da(o) esposa(o), caso seja casado(a).</b></p>
			</div>
		</div>
		<div class="item">
			<div class="icone">
				<i class="fas fa-arrow-alt-circle-right fa-8x color-accent fa-fw"></i>
			</div>
			<div class="info">
				<h3>Importante</h3>
				<br />
				<ul class="list-cycle">
					<li>A preferência na locação só será dada na entrega do cadastro, devidamente preenchido, assinado e com a documentação anexa</li>
					<li>Toda documentação poderá ser entregue por e-mail: <a href="mailto:{$mailDocumentacao}"><b>{$mailDocumentacao}</b></a> ou WhatsApp: <a href="{$linkWhatsappDocumentacao}" target="_blank" title="WhatsApp Locação"><b>{$textWhatsappDocumentacao}</b></a></li>
					<li>Caso o pretendente desista da locação, após a entrega do cadastro e documentos, será cobrada uma taxa de 20% sobre o salário mínimo, a fim de ressarcir despesas de pesquisas cadastrais</li>
				</ul>
			</div>
		</div>
	</div>
	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/garantias-locaticias" use:link replace title="Confira as garantias locatícias" class="btn btn-primary">Confira as garantias locatícias <i class="far fa-arrow-right"></i></a>
	</div>
	<br /><br />

</div>